import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { RowTableWithButtonPrograma } from "@/components/shared/RowTableWithButtonPrograma";
import { Separator } from "@/components/ui/separator";
import { CardHeader } from "@/components/shared/CardHeader";
import { InputWithLabel } from "@/components/shared/InputWithLabel";
import { Loading } from "@/components/shared/Loading";
import { AlertMessage } from "@/components/shared/AlertMessage";
import { IDisciplinasPosGraduacaoComponentProps } from "@/@types/PosGraduacao/Disciplinas";


/**
 * Componente para exibir as disciplinas de pós-graduação de acordo com o ano do catálogo.
 * @param ano O ano do catálogo.
 * @param data As disciplinas de pós-graduação.
 * @param setAno Função para atualizar o ano do catálogo.
 * @param isLoading Indica se os dados estão sendo carregados
 * @returns Componente de disciplinas de pós-graduação.
 */

const DisciplinasPosGraduacaoComponent = ({ ano, data, setAno, isLoading }: IDisciplinasPosGraduacaoComponentProps) => {
  return (
    <div className="mt-[25px] border-[1px] rounded-[0.25rem]">
      <CardHeader>
        <InputWithLabel
          label="Ano Catálogo"
          min={2014}
          type="number"
          value={ano}
          onChange={({ target }) => setAno(parseInt(target.value))}
        />
      </CardHeader>

      {isLoading ? (
        <Loading color="primary" />
      ) : (
        <>
          {data.length == 0 ? (
            <AlertMessage message='Não foi encontrada nenhuma matriz curricular.' />
          ) : (
            <>
                <div className="pt-[0.75rem] pb-[0.75rem] pr-[1.25rem] pl-[1.25rem]">
            <div className="mt-[25px]">
              <h4>Obrigatórias</h4>
              <Separator className="mt-[10px]" />
              <Table className="mt-[32px]">
                <TableHeader>
                  <TableRow>
                    <TableHead>
                      Ano Catálogo
                      <br />
                      Tipo
                      <br />
                      Oferecimento
                    </TableHead>
                    <TableHead>
                      Sigla
                      <br />
                      Disciplinas
                    </TableHead>
                    <TableHead>
                      Num Cred
                      <br />
                      CH
                      <br />
                      Período
                    </TableHead>
                    <TableHead>Programa</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {data.map((disciplina) => {
                    // renderiaza as diciplinas obrigatórias, que são AP197 e AP200
                    if (["AP197", "AP200"].includes(disciplina.COD_DISCI)) {
                      return <RowTableWithButtonPrograma data={disciplina} />;
                    }
                  })}
                </TableBody>
              </Table>
            </div>
            <div className="mt-[64px]">
              <h4>Eletivas</h4>
              <Separator className="mt-[10px]" />
              <Table className="mt-[32px]">
                <TableHeader>
                  <TableRow>
                    <TableHead>
                      Ano Catálogo
                      <br />
                      Tipo
                      <br />
                      Oferecimento
                    </TableHead>
                    <TableHead>
                      Sigla
                      <br />
                      Disciplinas
                    </TableHead>
                    <TableHead>
                      Num Cred
                      <br />
                      CH
                      <br />
                      Período
                    </TableHead>
                    <TableHead>Programa</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {data.map((disciplina) => {
                    // renderiza o restante das disciplinas, excluindo as obrigatórias (AP197 e AP200)
                    if (!["AP197", "AP200"].includes(disciplina.COD_DISCI)) {
                      return <RowTableWithButtonPrograma data={disciplina} />;
                    }
                  })}
                </TableBody>
              </Table>
            </div>
          </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export { DisciplinasPosGraduacaoComponent };
